const INITIAL_STATE = {
    files: []
};

const filesReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'SET_FILES':
            return {
                ...state,
                files: action.payload
            };
        default:
            return state;
    }
};

export default filesReducer;


// WEBPACK FOOTER //
// ./frontEnd/covid/permiso-unico-colectivo/reducers/filesReducer.js